import { useRouter } from 'next/router';
import { useEffect } from 'react';

import useCustomerStoryListingStore, { setCustomerStorySearch } from 'layout/Listing/variants/customerStories/store';

const useCustomerStoryFilterSearchParam = () => {
  const activeSearch = useCustomerStoryListingStore(state => state.search);
  const { push } = useRouter();

  useEffect(() => {
    const params = new URL(window.location.href).searchParams;
    const search = params?.get('s');

    search && search !== '' && setCustomerStorySearch(search);
  }, []);

  useEffect(() => {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    activeSearch ? params.set('s', activeSearch) : params.delete('s');

    const newUrl = url.toString();

    push(newUrl, newUrl, { shallow: true, scroll: false });
  }, [activeSearch]);
};

export default useCustomerStoryFilterSearchParam;
